import {
  isAnimationsDisabled,
  isDebug,
  isMobileApp,
  isPhysicsDebug,
} from "@/constants";
import type { User } from "@dndbeyond/auth/types/user";

export const getWorkerName = (
  name: string,
  nodeEnv: string,
  env: string,
  user?: User,
) =>
  JSON.stringify({
    name,
    isDebug,
    isPhysicsDebug,
    isMobileApp,
    isAnimationsDisabled,
    nodeEnv,
    env,
    ...(user && { user }),
  });
